import { render, staticRenderFns } from "./ComSearch.vue?vue&type=template&id=c4c24e9a&scoped=true&"
import script from "./ComSearch.vue?vue&type=script&lang=js&"
export * from "./ComSearch.vue?vue&type=script&lang=js&"
import style0 from "./ComSearch.vue?vue&type=style&index=0&id=c4c24e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c24e9a",
  null
  
)

export default component.exports